import LOGO from "../images/Apaches.png";

export const Team__Apaches = {
  name: "Apaches",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#af8150",
  teamJerseyColor: "#BD3737",
  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  // goalsScoredAgainst: 50 + 48 + 60, 
  goalsScoredAgainst: 50 + 48, 
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      // goalsScored: 57 + 34 + 32,
      goalsScored: 57 + 34, 
    },
  ],
};
